import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoTranscriptionScopeEmptyState = props => {
  const {
    isTranscriptionAdmin
  } = props;
  const attrs = isTranscriptionAdmin ? {
    elements: {
      UILink: Link
    },
    options: {
      href: `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/paid-users`,
      target: '_top'
    }
  } : null;
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "integrations",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptAvailable"
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: isTranscriptionAdmin ? /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptionScope.isAdmin.description_jsx"
      }, attrs)) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptionScope.isNotAdmin.description"
      })
    })
  });
};